import { motion } from 'framer-motion';

export default function Datenschutz() {
  return (
    <div data-testid="datenschutz-page" className="min-h-screen bg-cream">
      {/* Header */}
      <section className="pt-32 pb-16 bg-olive-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="font-heading text-4xl md:text-5xl text-cream"
          >
            Datenschutzerklärung
          </motion.h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white p-8 md:p-12 shadow-[0_4px_20px_-2px_rgba(0,0,0,0.1)]"
          >
            <div className="prose prose-olive max-w-none font-body text-muted-foreground">
              
              {/* 1. Datenschutz auf einen Blick */}
              <h2 className="font-heading text-2xl text-olive-900 mt-0">1. Datenschutz auf einen Blick</h2>
              
              <h3 className="font-heading text-xl text-olive-900">Allgemeine Hinweise</h3>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen 
                Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit 
                denen Sie persönlich identifiziert werden können.
              </p>

              <h3 className="font-heading text-xl text-olive-900">Datenerfassung auf dieser Website</h3>
              
              <h4 className="font-heading text-lg text-olive-900">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
              <p>
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten 
                können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
              </p>

              <h4 className="font-heading text-lg text-olive-900">Wie erfassen wir Ihre Daten?</h4>
              <p>
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich 
                z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch 
                oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst.
              </p>

              <h4 className="font-heading text-lg text-olive-900">Welche Rechte haben Sie bezüglich Ihrer Daten?</h4>
              <p>
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer 
                gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung 
                oder Löschung dieser Daten zu verlangen.
              </p>

              {/* 2. Hosting */}
              <h2 className="font-heading text-2xl text-olive-900">2. Hosting</h2>
              <p>Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>
              
              <h3 className="font-heading text-xl text-olive-900">DomainFactory</h3>
              <p>
                Anbieter ist die DomainFactory GmbH, c/o WeWork, Neuturmstraße 5, 80331 München. 
                Wenn Sie unsere Website besuchen, erfasst DomainFactory verschiedene Logfiles inklusive Ihrer IP-Adressen.
              </p>
              <p>
                Details entnehmen Sie der Datenschutzerklärung von DomainFactory:{' '}
                <a href="https://www.df.eu/de/datenschutz/" target="_blank" rel="noopener noreferrer" className="text-terracotta hover:underline">
                  https://www.df.eu/de/datenschutz/
                </a>
              </p>

              {/* 3. Allgemeine Hinweise */}
              <h2 className="font-heading text-2xl text-olive-900">3. Allgemeine Hinweise und Pflichtinformationen</h2>
              
              <h3 className="font-heading text-xl text-olive-900">Datenschutz</h3>
              <p>
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
                Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen 
                Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>

              <h3 className="font-heading text-xl text-olive-900">Hinweis zur verantwortlichen Stelle</h3>
              <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
              <p className="bg-cream-dark p-4 rounded">
                <strong>Ivan Muggianu</strong><br />
                Zeppelinstr. 15<br />
                85399 Hallbergmoos<br /><br />
                Telefon: <a href="tel:+498119999888" className="text-terracotta hover:underline">0811/999 98 88</a><br />
                E-Mail: <a href="mailto:info@ristorante-ilgirasole.de" className="text-terracotta hover:underline">info@ristorante-ilgirasole.de</a>
              </p>

              <h3 className="font-heading text-xl text-olive-900">Speicherdauer</h3>
              <p>
                Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, 
                verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.
              </p>

              <h3 className="font-heading text-xl text-olive-900">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
              <p>
                Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. 
                Sie können eine bereits erteilte Einwilligung jederzeit widerrufen.
              </p>

              <h3 className="font-heading text-xl text-olive-900">Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
              <p>
                Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer 
                Aufsichtsbehörde zu.
              </p>

              <h3 className="font-heading text-xl text-olive-900">Recht auf Datenübertragbarkeit</h3>
              <p>
                Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines 
                Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, 
                maschinenlesbaren Format aushändigen zu lassen.
              </p>

              <h3 className="font-heading text-xl text-olive-900">SSL- bzw. TLS-Verschlüsselung</h3>
              <p>
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte 
                eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass 
                die Adresszeile des Browsers von „http://" auf „https://" wechselt.
              </p>

              {/* 4. Datenerfassung */}
              <h2 className="font-heading text-2xl text-olive-900">4. Datenerfassung auf dieser Website</h2>
              
              <h3 className="font-heading text-xl text-olive-900">Cookies</h3>
              <p>
                Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Datenpakete und 
                richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer 
                einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
              </p>

              <h3 className="font-heading text-xl text-olive-900">Einwilligung mit Borlabs Cookie</h3>
              <p>
                Unsere Website nutzt die Consent-Technologie von Borlabs Cookie, um Ihre Einwilligung zur 
                Speicherung bestimmter Cookies in Ihrem Browser einzuholen und diese datenschutzkonform zu dokumentieren.
              </p>

              <h3 className="font-heading text-xl text-olive-900">Anfrage per E-Mail, Telefon oder Telefax</h3>
              <p>
                Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller 
                daraus hervorgehenden personenbezogenen Daten zum Zwecke der Bearbeitung Ihres Anliegens bei 
                uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>

              {/* 5. Analyse-Tools */}
              <h2 className="font-heading text-2xl text-olive-900">5. Analyse-Tools und Werbung</h2>
              
              <h3 className="font-heading text-xl text-olive-900">Google Analytics</h3>
              <p>
                Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die 
                Google Ireland Limited („Google"), Gordon House, Barrow Street, Dublin 4, Irland.
              </p>
              <p>
                Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO. 
                Die Einwilligung ist jederzeit widerrufbar.
              </p>
              <p>
                Sie können die Erfassung durch Google verhindern, indem Sie das Browser-Plugin herunterladen:{' '}
                <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noopener noreferrer" className="text-terracotta hover:underline">
                  https://tools.google.com/dlpage/gaoptout?hl=de
                </a>
              </p>

              {/* 6. Newsletter */}
              <h2 className="font-heading text-2xl text-olive-900">6. Newsletter</h2>
              <p>
                Wenn Sie den auf der Website angebotenen Newsletter beziehen möchten, benötigen wir von Ihnen 
                eine E-Mail-Adresse sowie Informationen, welche uns die Überprüfung gestatten, dass Sie der 
                Inhaber der angegebenen E-Mail-Adresse sind.
              </p>

              {/* 7. Plugins und Tools */}
              <h2 className="font-heading text-2xl text-olive-900">7. Plugins und Tools</h2>
              
              <h3 className="font-heading text-xl text-olive-900">Google Fonts (lokales Hosting)</h3>
              <p>
                Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten Google Fonts. 
                Die Google Fonts sind lokal installiert. Eine Verbindung zu Servern von Google findet dabei nicht statt.
              </p>

              <h3 className="font-heading text-xl text-olive-900">Google Maps</h3>
              <p>
                Diese Seite nutzt den Kartendienst Google Maps. Anbieter ist die Google Ireland Limited, 
                Gordon House, Barrow Street, Dublin 4, Irland. Zur Nutzung der Funktionen von Google Maps 
                ist es notwendig, Ihre IP-Adresse zu speichern.
              </p>

              <h3 className="font-heading text-xl text-olive-900">Google reCAPTCHA</h3>
              <p>
                Wir nutzen „Google reCAPTCHA" auf dieser Website. Mit reCAPTCHA soll überprüft werden, 
                ob die Dateneingabe auf dieser Website durch einen Menschen oder durch ein automatisiertes 
                Programm erfolgt.
              </p>

              {/* 8. eCommerce */}
              <h2 className="font-heading text-2xl text-olive-900">8. eCommerce und Zahlungsanbieter</h2>
              
              <h3 className="font-heading text-xl text-olive-900">Verarbeiten von Kunden- und Vertragsdaten</h3>
              <p>
                Wir erheben, verarbeiten und nutzen personenbezogene Kunden- und Vertragsdaten zur Begründung, 
                inhaltlichen Ausgestaltung und Änderung unserer Vertragsbeziehungen. Die erhobenen Kundendaten 
                werden nach Abschluss des Auftrags oder Beendigung der Geschäftsbeziehung und Ablauf der ggf. 
                bestehenden gesetzlichen Aufbewahrungsfristen gelöscht.
              </p>

            </div>
          </motion.div>

          {/* Stand */}
          <div className="mt-8 text-center">
            <p className="font-body text-muted-foreground text-sm">
              Stand: Dezember 2024
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
